export const DEFAULT_INBOX_COLOR = '#1f93ff';

export const normalizeInboxColor = color => {
  if (!color || typeof color !== 'string') return DEFAULT_INBOX_COLOR;
  const value = color.trim();
  if (/^#[0-9A-Fa-f]{6}$/.test(value)) return value;
  if (/^#[0-9A-Fa-f]{3}$/.test(value)) {
    return `#${value[1]}${value[1]}${value[2]}${value[2]}${value[3]}${value[3]}`;
  }
  return DEFAULT_INBOX_COLOR;
};

export const isDashboardDarkTheme = () =>
  typeof document !== 'undefined' && document.body.classList.contains('dark');

/** Channel color for the active appearance (light / dark). */
export const resolveInboxThemeColor = inbox => {
  if (!inbox) return DEFAULT_INBOX_COLOR;
  if (isDashboardDarkTheme()) {
    return normalizeInboxColor(inbox.color_dark || inbox.color);
  }
  return normalizeInboxColor(inbox.color);
};

export const softInboxSurface = (color, { percent = 14 } = {}) => {
  const accent = normalizeInboxColor(color);
  if (typeof percent === 'object') {
    return `color-mix(in srgb, ${accent} 12%, transparent)`;
  }
  return `color-mix(in srgb, ${accent} ${percent}%, transparent)`;
};

export const softInboxHeader = color => softInboxSurface(color, { percent: 32 });

export const solidInboxHeader = color => normalizeInboxColor(color);

export const inboxAccentColor = (colorOrInbox, maybeInbox) => {
  if (colorOrInbox && typeof colorOrInbox === 'object') {
    return resolveInboxThemeColor(colorOrInbox);
  }
  if (maybeInbox && typeof maybeInbox === 'object') {
    return resolveInboxThemeColor(maybeInbox);
  }
  return normalizeInboxColor(colorOrInbox);
};

/** Readable text color over a channel accent (yellow → dark, navy → white). */
export const contrastTextOnInboxColor = color => {
  const hex = normalizeInboxColor(color).replace('#', '');
  const r = parseInt(hex.slice(0, 2), 16);
  const g = parseInt(hex.slice(2, 4), 16);
  const b = parseInt(hex.slice(4, 6), 16);
  const yiq = (r * 299 + g * 587 + b * 114) / 1000;
  return yiq >= 150 ? '#111827' : '#ffffff';
};
